// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ccn-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
}

.ccn-modal {
  width: 90%;
  max-width: 420px;
  background: var(--surface-secondary, #1a1a24);
  border: 1px solid var(--border-subtle, rgba(255, 255, 255, 0.1));
  border-radius: 16px;
  padding: 28px 24px 24px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6);
  animation: ccnModalIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes ccnModalIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(8px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.ccn-counter {
  text-align: center;
  margin-bottom: 4px;
  min-height: 18px;
}

.ccn-counter-text {
  font-size: 0.7rem;
  color: var(--text-muted, rgba(255, 255, 255, 0.4));
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.ccn-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
}

.ccn-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ccn-icon-refund {
  background: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.ccn-icon-swap {
  background: rgba(168, 85, 247, 0.15);
  color: #a855f7;
}

.ccn-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text-primary, #fff);
  margin: 0;
}

.ccn-desc {
  font-size: 0.85rem;
  color: var(--text-secondary, rgba(255, 255, 255, 0.7));
  line-height: 1.5;
  margin: 0;
}

.ccn-desc-sub {
  font-size: 0.8rem;
  color: var(--text-muted, rgba(255, 255, 255, 0.5));
}

.ccn-desc-prompt {
  font-size: 0.8rem;
  color: var(--text-secondary, rgba(255, 255, 255, 0.6));
  margin-top: 4px;
}

.ccn-old-price {
  text-decoration: line-through;
  color: var(--text-muted, rgba(255, 255, 255, 0.4));
}

.ccn-new-price {
  color: #22c55e;
  font-weight: 700;
}

.ccn-refund-amount {
  font-size: 1.2rem;
  font-weight: 800;
  color: #22c55e;
  padding: 10px 20px;
  border-radius: 10px;
  background: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.ccn-btn {
  padding: 10px 32px;
  border-radius: 10px;
  font-size: 0.85rem;
  font-weight: 700;
  border: none;
  cursor: pointer;
  transition: opacity 0.15s;
  margin-top: 4px;
}

.ccn-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.ccn-btn-primary {
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-primary, #fff);
  border: 1px solid rgba(255, 255, 255, 0.15);
}

.ccn-btn-primary:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.15);
}

/* ── Effect choice buttons ───────────────────────────────── */

.ccn-choices {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-top: 4px;
}

.ccn-choice-btn {
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.04);
  cursor: pointer;
  text-align: left;
  transition: background 0.15s, border-color 0.15s;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ccn-choice-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

.ccn-choice-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

.ccn-choice-keep:hover:not(:disabled) {
  border-color: rgba(34, 197, 94, 0.4);
}

.ccn-choice-swap:hover:not(:disabled) {
  border-color: rgba(168, 85, 247, 0.4);
}

.ccn-choice-label {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--text-primary, #fff);
}

.ccn-choice-detail {
  font-size: 0.75rem;
  color: var(--text-muted, rgba(255, 255, 255, 0.45));
}

.ccn-choice-or {
  font-size: 0.7rem;
  color: var(--text-muted, rgba(255, 255, 255, 0.3));
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

@media (max-width: 1800px) {
  .ccn-overlay {
    padding: 16px;
  }

  .ccn-modal {
    max-width: 390px;
    padding: 24px 20px 22px;
    border-radius: 14px;
  }

  .ccn-content {
    gap: 10px;
  }

  .ccn-icon {
    width: 48px;
    height: 48px;
  }

  .ccn-title {
    font-size: 1.03rem;
  }

  .ccn-desc {
    font-size: 0.82rem;
  }

  .ccn-desc-sub,
  .ccn-desc-prompt {
    font-size: 0.76rem;
  }

  .ccn-refund-amount {
    padding: 9px 18px;
    font-size: 1.1rem;
  }

  .ccn-btn {
    padding: 9px 28px;
    font-size: 0.82rem;
  }

  .ccn-choices {
    gap: 7px;
  }

  .ccn-choice-btn {
    padding: 12px 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CardChangeNoticeModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,6CAA6C;EAC7C,gEAAgE;EAChE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;EAC1C,wDAAwD;AAC1D;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,sDAAsD;EACtD,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA,+DAA+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".ccn-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n}\n\n.ccn-modal {\n  width: 90%;\n  max-width: 420px;\n  background: var(--surface-secondary, #1a1a24);\n  border: 1px solid var(--border-subtle, rgba(255, 255, 255, 0.1));\n  border-radius: 16px;\n  padding: 28px 24px 24px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.6);\n  animation: ccnModalIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes ccnModalIn {\n  from {\n    opacity: 0;\n    transform: scale(0.95) translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.ccn-counter {\n  text-align: center;\n  margin-bottom: 4px;\n  min-height: 18px;\n}\n\n.ccn-counter-text {\n  font-size: 0.7rem;\n  color: var(--text-muted, rgba(255, 255, 255, 0.4));\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.ccn-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 12px;\n}\n\n.ccn-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.ccn-icon-refund {\n  background: rgba(34, 197, 94, 0.15);\n  color: #22c55e;\n}\n\n.ccn-icon-swap {\n  background: rgba(168, 85, 247, 0.15);\n  color: #a855f7;\n}\n\n.ccn-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text-primary, #fff);\n  margin: 0;\n}\n\n.ccn-desc {\n  font-size: 0.85rem;\n  color: var(--text-secondary, rgba(255, 255, 255, 0.7));\n  line-height: 1.5;\n  margin: 0;\n}\n\n.ccn-desc-sub {\n  font-size: 0.8rem;\n  color: var(--text-muted, rgba(255, 255, 255, 0.5));\n}\n\n.ccn-desc-prompt {\n  font-size: 0.8rem;\n  color: var(--text-secondary, rgba(255, 255, 255, 0.6));\n  margin-top: 4px;\n}\n\n.ccn-old-price {\n  text-decoration: line-through;\n  color: var(--text-muted, rgba(255, 255, 255, 0.4));\n}\n\n.ccn-new-price {\n  color: #22c55e;\n  font-weight: 700;\n}\n\n.ccn-refund-amount {\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: #22c55e;\n  padding: 10px 20px;\n  border-radius: 10px;\n  background: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n}\n\n.ccn-btn {\n  padding: 10px 32px;\n  border-radius: 10px;\n  font-size: 0.85rem;\n  font-weight: 700;\n  border: none;\n  cursor: pointer;\n  transition: opacity 0.15s;\n  margin-top: 4px;\n}\n\n.ccn-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.ccn-btn-primary {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--text-primary, #fff);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.ccn-btn-primary:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n/* ── Effect choice buttons ───────────────────────────────── */\n\n.ccn-choices {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  margin-top: 4px;\n}\n\n.ccn-choice-btn {\n  width: 100%;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.04);\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s, border-color 0.15s;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ccn-choice-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.ccn-choice-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n.ccn-choice-keep:hover:not(:disabled) {\n  border-color: rgba(34, 197, 94, 0.4);\n}\n\n.ccn-choice-swap:hover:not(:disabled) {\n  border-color: rgba(168, 85, 247, 0.4);\n}\n\n.ccn-choice-label {\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: var(--text-primary, #fff);\n}\n\n.ccn-choice-detail {\n  font-size: 0.75rem;\n  color: var(--text-muted, rgba(255, 255, 255, 0.45));\n}\n\n.ccn-choice-or {\n  font-size: 0.7rem;\n  color: var(--text-muted, rgba(255, 255, 255, 0.3));\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n}\n\n@media (max-width: 1800px) {\n  .ccn-overlay {\n    padding: 16px;\n  }\n\n  .ccn-modal {\n    max-width: 390px;\n    padding: 24px 20px 22px;\n    border-radius: 14px;\n  }\n\n  .ccn-content {\n    gap: 10px;\n  }\n\n  .ccn-icon {\n    width: 48px;\n    height: 48px;\n  }\n\n  .ccn-title {\n    font-size: 1.03rem;\n  }\n\n  .ccn-desc {\n    font-size: 0.82rem;\n  }\n\n  .ccn-desc-sub,\n  .ccn-desc-prompt {\n    font-size: 0.76rem;\n  }\n\n  .ccn-refund-amount {\n    padding: 9px 18px;\n    font-size: 1.1rem;\n  }\n\n  .ccn-btn {\n    padding: 9px 28px;\n    font-size: 0.82rem;\n  }\n\n  .ccn-choices {\n    gap: 7px;\n  }\n\n  .ccn-choice-btn {\n    padding: 12px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
